//may replace button-with-dropdown from global atoms
import {
  Button,
  ButtonOwnProps,
  ButtonProps,
  ListItemButton,
  ListItemText,
  Popover,
} from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { lightNeutral } from 'src/colors';
import { usePopover } from 'src/hooks/use-popover';
import { ChevronDown } from 'src/icons/chevron-down';

interface Props extends ButtonProps {
  items: {
    leadingSlot?: ReactNode;
    text: string;
    onClick: () => void;
  }[];
  children: ReactNode;
  variant: ButtonOwnProps['variant'];
}

export const ButtonSelect = ({ children, variant, items, ...other }: Props) => {
  const { t } = useTranslation();
  const [anchorRef, open, handleOpen, handleClose] = usePopover();

  return (
    <>
      <Button
        ref={anchorRef}
        variant={variant}
        onClick={handleOpen}
        {...other}
        endIcon={
          <ChevronDown
            sx={{
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          />
        }>
        {children}
      </Button>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        slotProps={{
          paper: {
            sx: {
              border: `1px solid ${lightNeutral[300]}`,
            },
          },
        }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}>
        {items.map(item => (
          <ListItemButton
            key={item.text}
            onClick={() => {
              item.onClick();
              handleClose();
            }}
            sx={{
              border: 'none',
              outline: 'none',
            }}>
            <ListItemText primary={t(item.text)} />
          </ListItemButton>
        ))}
      </Popover>
    </>
  );
};
